import { PathName, PermissionsNames } from '../constants';

/**
 * we need separate configuration for the PricingManager component to handle router.
 * More information: https://github.prod.hulu.com/AdPlatformV2/mission-control-ui/pull/1584
 * And revert commit: https://github.prod.hulu.com/AdPlatformV2/mission-control-ui/commit/88b29dc1916b2ded0b6d0569fba869db9115da08
 */
export const pricingManagerConfig = {
  name: 'pricing-manager-ui-plugin',
  route: PathName.pricing,
  permissionName: PermissionsNames.pricingPageRead,
  getComponent: () => import('pricing-manager-ui-plugin'),
};

const configuration = [
  {
    name: 'access-manager-ui-plugin',
    route: PathName.accessManager,
    permissionName: PermissionsNames.accessManagerPageRead,
    getComponent: () => import('access-manager-ui-plugin'),
  },
];
export default configuration;
